import { render, staticRenderFns } from "./dataSourceTransactionLinkSetting.vue?vue&type=template&id=26af2a8a&scoped=true&"
import script from "./dataSourceTransactionLinkSetting.vue?vue&type=script&lang=js&"
export * from "./dataSourceTransactionLinkSetting.vue?vue&type=script&lang=js&"
import style0 from "./dataSourceTransactionLinkSetting.vue?vue&type=style&index=0&id=26af2a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26af2a8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VIcon,VSelect,VSheet,VSpacer})
